"use strict";
// export function scope(name: string, namespace: string, separator: string = '-') {
//     return namespace ? namespace + separator + name : name;
// }
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecated = exports.string2varname = exports.filename2varname = exports.stripQuotation = void 0;
function stripQuotation(str) {
    return str.replace(/^['"](.*?)['"]$/g, '$1');
}
exports.stripQuotation = stripQuotation;
function filename2varname(filename) {
    return string2varname(filename.replace(/(?=.*)\.\w+$/, '').replace(/\.st$/, ''));
}
exports.filename2varname = filename2varname;
function string2varname(str) {
    return str.replace(/[^0-9a-zA-Z_]/gm, '').replace(/^[^a-zA-Z_]+/gm, '');
}
exports.string2varname = string2varname;
const deprecatedCache = {};
function deprecated(staticMessage) {
    if (!deprecatedCache[staticMessage]) {
        deprecatedCache[staticMessage] = true;
        try {
            console.warn('DEPRECATED: ' + staticMessage);
        }
        catch {
            /**/
        }
    }
}
exports.deprecated = deprecated;
//# sourceMappingURL=utils.js.map